import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@src/store';
import { chatbotActions } from '@src/store/reducers/chatbotReducer';
import { ChatbotConnectionService } from '@src/services/ChatbotConnectionService.service';
import { Utils } from '@src/utils/util';


@Component({
    selector: 'chatbot-item',
    template: require('./chatbot-item.component.html'),
    styles: [require('./chatbot-item.component.scss')]
})
export class ChatbotItemComponent implements OnInit {
    @Output() public onDelete = new EventEmitter();
    @Output() public onSave = new EventEmitter();
    @Output() public onTest = new EventEmitter<any>();
    @Output() public onCancel = new EventEmitter<any>();
    @ViewChild('settingsContainer') public settingsContainer: ElementRef;

    public hasItemEditable = true;
    public chatbotTypeList = [];

    private unSubscribe: any;
    private _chatbot: any;
    private tempChatbot: any;
    public configuration: any = {};
    public hidePass: boolean = true;
        
    public component: any;
    @Output() public onEditLink = new EventEmitter();

    constructor(private store: Store,
                private componentService: ChatbotConnectionService,
                private utils: Utils) {

    }
    
    @Input()
    public set chatbot(value) {
        this.configuration = {};        
        this.tempChatbot = this.utils.deepCopy(value);
        this._chatbot = value;
        this.hasItemEditable = !this.chatbot;
        this.setChatbotType();
        if (value && value.Configuration) {
            this.configuration = value.Configuration;
            this.selectConfig();
        }       
    }

    public get chatbot() {
        return this._chatbot;
    }

    public set selectedChatbot(value: any) {
        this.chatbot.ChatbotType = value.Name;
        this.chatbot.ChatbotTypeId = value.ID;
    }

    public get selectedChatbot() {
        return this.setChatbotType();
    }

    public async ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {            
            const chatbots = this.store.getState().chatbots;
                        
            if (chatbots && chatbots.chatbot_types) {
                this.chatbotTypeList = chatbots.chatbot_types;
                this.setChatbotType();
                if (this.chatbotTypeList.length > 0) {
                    this.unSubscribe();
                }
            }
        });
        this.store.dispatch({ type: chatbotActions.GET_CHATBOT_TYPES });
    }

    public async save() {
        if (this.chatbot.Configuration.AccessInCredentials) {
            delete this.chatbot.Configuration.AccessKey;
            delete this.chatbot.Configuration.SecretAccessKey;
        }
        const copyChatbot = this.utils.deepCopy(this.chatbot);

        if (this.chatbot.IsNew) {
            delete copyChatbot.IsNew;
            delete copyChatbot.ID;
            const chatbotId: string = await this.store.dispatch({
                type: chatbotActions.SET_CHATBOT_CONFIGURATION,
                payload: { chatbot_configuration: copyChatbot }
            });
            //this.chatbot.IsNew = false;
            if (chatbotId) {
                this.store.dispatch({ type: chatbotActions.GET_CHATBOTS });
                delete this.chatbot.IsNew;
                this.onSave.emit(chatbotId);
            }
        } else {
            const saveID = this.chatbot.ID;
            this.unSubscribe = this.store.subscribe(() => {
                if (this.store.getState().user.chatbot) {
                    this.chatbot.ID = saveID;
                    this.unSubscribe();
                }
            });
            this.store.dispatch({
                type: chatbotActions.UPDATE_CHATBOT_CONFIGURATION,
                payload: { update_chatbot: copyChatbot }
            });
        }
    }

    public cancel() {
        const chatbot = Object.assign({}, this.tempChatbot);
        this.chatbot = chatbot;
        this.onCancel.emit(chatbot);
    }

    public setChatbotType(): string {
        if (this.chatbotTypeList && this.chatbot) {
            const chatbotTypeId = this.chatbot.ChatbotTypeId;
            const type = this.chatbotTypeList.find((type) => {
                return type.ID === chatbotTypeId;
            });
            if (type) {
                this.chatbot.ChatbotType = type.Name;
                this.chatbot.ChatbotTypeId = type.ID;
                return type;
            }
        }
    }

    private selectConfig() {
        /*this.component = null;
        this.store.dispatch({
            type: chatbotActions.GET_CHATBOT_CONFIGURATION,
            payload: { chatbotTypeId: this.chatbot.ChatbotTypeId }
        }).then((res) => {
            this.createPage(res);
        });*/
        let htmlConnTemplate = '';
            htmlConnTemplate = 
          '<style>' +
          '.tooltip-Q {'+
           ' vertical-align: middle;'+
            'display: inline-block;'+
          '}'+
      
          '.tooltip-Q:before {'+
            'content: \"\\F13D\";'+
            'vertical-align: middle;'+
            'display: inline-block;'+
            'font-family: DBmaestro !important;'+
          '}'+
        '</style>'+
          '<div class=\"flex connection-settings-buffer\">'+
            '<label class=\"chatbot-input-margin\">'+
              '<div class=\"container-section-input-label\">API Key</div>'+
              '<input class=\"form-control dbm-input container-section-input chatbot-section-input\" [(ngModel)]=\"data && data.ApiKey\" [disabled]=\"hasItemEditable\">'+
            '</label>  '+
          '</div>'+
          '<div class=\"flex connection-settings-buffer\">'+
            '<label class=\"chatbot-input-margin\">'+
              '<div class=\"container-section-input-label\">Model</div>'+
              '<input class=\"form-control dbm-input container-section-input chatbot-section-input\" [(ngModel)]=\"data && data.Model\" [disabled]=\"hasItemEditable\">'+
            '</label>  '+
          '</div>'+
          '<div class=\"flex connection-settings-buffer\">'+
            '<label class=\"chatbot-input-margin\">'+
              '<div class=\"container-section-input-label\">Max Tokens</div>'+
              '<input class=\"form-control dbm-input container-section-input chatbot-section-input\" [(ngModel)]=\"chatbot && chatbot.Configuration.MaxTokens\" [disabled]=\"hasItemEditable\">'+
            '</label>  '+
          '</div>' +
          '<div class=\"flex connection-settings-buffer\">'+
            '<label class=\"chatbot-input-margin\">'+
              '<div class=\"container-section-input-label\">Prompt</div>'+
              '<input class=\"form-control dbm-input container-section-input chatbot-section-input\" [(ngModel)]=\"data && data.template\" [disabled]=\"hasItemEditable\">'+
            '</label>  '+
          '</div>'
          
          this.createPage(htmlConnTemplate);6
    }

    public createPage(htmlTemplate) {
       
        this.component = this.componentService.createComponent(htmlTemplate);      
        
        //this.setData(this.chatbot);
    }

    public setData = (instance: any) => {
        if (this.configuration.AccessInCredentials === undefined) {
            this.configuration.AccessInCredentials = false;
        }
        instance.isDisabled = true;
        instance.isHidden = true;
        instance.data = this.configuration;
        instance.onEditLink = this.onEditLink;
        ///instance.data.template = Math.random().toString(36).substring(7);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/chatbot-management/chatbot-item/chatbot-item.component.ts